// extracted by mini-css-extract-plugin
export var moreBtn = "projects-module--more-btn--mduAu";
export var projectFilters = "projects-module--project-filters--LZtPn";
export var projectsSection = "projects-module--projects-section--7aq6A";